<template>
  <div class="navbar-user">
    <div class="container" v-if="company">
      <div
        class="navbar-user__logo"
        :style="{ backgroundImage: `url(${company.image})` }"
      ></div>
      <div class="navbar-user__name">
        <h4>{{ this.company.name }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["user", "company"]),
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: "Login" });
        });
    },
  },
};
</script>

<style lang="scss">
.navbar-user {
  position: relative;
  padding: 5em 0;

  &__logo {
    display: block;
    margin: 0 auto;
    width: 5em;
    height: 5em;
    border-radius: 50%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    box-shadow: $shadow_sm;
  }
  &__name {
    padding: 1.5em 0;
    text-align: center;
    color: $lightred;
  }
  &__settings {
    ul {
      list-style-type: none;
      text-align: center;
      li {
        margin: 0 0 0.25em;
        cursor: pointer;
        &:hover {
          a {
            color: $lightred;
            transition: $transition;
          }
        }
        a {
          color: $darkgray;
          text-decoration: none;
          transition: $transition;
        }
      }
    }
  }
}
</style>
